
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[dochatConfigId]",
      function () {
        return require("private-next-pages/[dochatConfigId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[dochatConfigId]"])
      });
    }
  